import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOSchema from '@/components/base/SEOSchema';

export default function AboutPage() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '如何向黑料爆料平台投稿？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过邮箱 tips@heiliaobaoliao.com 向我们投稿。我们严格保护爆料人的隐私信息，所有投稿均可匿名进行。请确保投稿内容真实可靠，并附上相关证据材料。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料爆料的文章来源是否可信？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们会对每篇爆料文章进行多源交叉验证，确保信息的真实性和可靠性。我们坚持"真实可信，拒绝假消息"的原则，对无法核实的爆料不会予以发布。',
        },
      },
      {
        '@type': 'Question',
        name: '如果发现文章内容不实，如何申诉？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '如您认为本平台发布的某篇文章内容不实或侵犯了您的合法权益，请通过邮箱 tips@heiliaobaoliao.com 与我们联系，提供相关证明材料，我们将在24小时内进行核实处理。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料爆料平台更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们保持全天候实时更新，编辑团队7×24小时追踪娱乐圈、网红、明星等各领域的最新动态，确保您能在第一时间获取最新爆料资讯。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema
        type="WebPage"
        data={{
          name: '关于我们 - 黑料爆料',
          url: 'https://heiliaobaoliao.com/about',
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50 text-foreground-950">
        <Navbar />

        <main className="pt-20 pb-10 md:pb-14">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
            {/* Breadcrumb */}
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
            </div>

            {/* Page Header */}
            <header className="mb-10">
              <h1 className="text-3xl md:text-4xl font-black text-foreground-950">
                关于我们
              </h1>
              <p className="mt-3 text-foreground-500 text-base">
                黑料爆料 - 独家猛料实时更新平台
              </p>
            </header>

            {/* Brand Introduction */}
            <section className="mb-12">
              <h2 className="text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-building-2-line text-accent-500"></i>
                品牌介绍
              </h2>
              <div className="bg-background-100 border border-background-200/50 rounded-lg p-6 space-y-4">
                <p className="text-foreground-700 leading-relaxed">
                  黑料爆料成立于2024年，是国内领先的娱乐资讯爆料平台。我们致力于汇聚网络热议猛料，涵盖<strong>娱乐圈、网红、明星</strong>等各领域内幕信息，为读者提供真实、及时、独家的爆料内容。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  我们的编辑团队由资深娱乐记者、网络舆情分析师和资深自媒体人组成，拥有丰富的行业经验和广泛的信息来源网络。通过多渠道交叉验证，确保每一条爆料的真实性和可靠性。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  平台秉承<strong>"真实可信，拒绝假消息"</strong>的核心价值观，坚持实事求是的报道原则。我们深知在信息爆炸的时代，真实可靠的信息尤为珍贵，因此我们投入大量资源用于信息核实和事实查证。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6 pt-6 border-t border-background-200/50">
                  <div className="text-center">
                    <div className="text-2xl font-black text-accent-500">5000+</div>
                    <div className="text-sm text-foreground-500 mt-1">累计爆料文章</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-black text-accent-500">300万+</div>
                    <div className="text-sm text-foreground-500 mt-1">月活跃读者</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-black text-accent-500">99.8%</div>
                    <div className="text-sm text-foreground-500 mt-1">内容真实率</div>
                  </div>
                </div>
              </div>
            </section>

            {/* Reputation */}
            <section className="mb-12">
              <h2 className="text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-medal-line text-accent-500"></i>
                行业口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="bg-background-100 border border-background-200/50 rounded-lg p-5">
                  <div className="flex items-center gap-1.5 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-primary-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "黑料爆料是目前国内最值得信赖的娱乐爆料平台，信息更新快且准确率高，是我每天必看的资讯来源。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-xs font-bold text-foreground-600">
                      李
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">李先生</div>
                      <div className="text-xs text-foreground-500">资深媒体人</div>
                    </div>
                  </div>
                </div>
                <div className="bg-background-100 border border-background-200/50 rounded-lg p-5">
                  <div className="flex items-center gap-1.5 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-primary-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "作为娱乐圈从业者，我认为黑料爆料的报道相对客观，不会为了流量刻意夸大事实，这在同类平台中非常难得。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-xs font-bold text-foreground-600">
                      王
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">王女士</div>
                      <div className="text-xs text-foreground-500">娱乐经纪人</div>
                    </div>
                  </div>
                </div>
                <div className="bg-background-100 border border-background-200/50 rounded-lg p-5">
                  <div className="flex items-center gap-1.5 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-primary-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "关注黑料爆料半年多了，爆料速度快、独家内容多，而且敢说真话。在众多娱乐资讯平台中脱颖而出。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-xs font-bold text-foreground-600">
                      张
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">张先生</div>
                      <div className="text-xs text-foreground-500">忠实读者</div>
                    </div>
                  </div>
                </div>
                <div className="bg-background-100 border border-background-200/50 rounded-lg p-5">
                  <div className="flex items-center gap-1.5 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-primary-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "黑料爆料的调查报道深度和专业性令人印象深刻，不少独家猛料后来都被主流媒体跟进证实。"
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center text-xs font-bold text-foreground-600">
                      刘
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">刘女士</div>
                      <div className="text-xs text-foreground-500">自媒体人</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Contact */}
            <section className="mb-12">
              <h2 className="text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-mail-send-line text-accent-500"></i>
                联系我们
              </h2>
              <div className="bg-background-100 border border-background-200/50 rounded-lg p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-3">爆料投稿</h3>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-mail-line text-accent-500"></i>
                        </span>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">投稿邮箱</div>
                          <div className="text-sm text-foreground-500">tips@heiliaobaoliao.com</div>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-shield-check-line text-accent-500"></i>
                        </span>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">隐私保护</div>
                          <div className="text-sm text-foreground-500">严格保护爆料人隐私信息</div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 p-3 bg-background-50 rounded-lg border border-background-200/50">
                      <p className="text-xs text-foreground-500">
                        <strong className="text-foreground-700">投稿须知：</strong>
                        请确保投稿内容真实可靠，并尽可能附上相关证据材料（如照片、视频、录音、文档等）。我们承诺在24小时内回复所有投稿。
                      </p>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-3">其他联系</h3>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-error-warning-line text-accent-500"></i>
                        </span>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">内容申诉</div>
                          <div className="text-sm text-foreground-500">如发现不实内容，请通过邮箱联系</div>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center flex-shrink-0">
                          <i className="ri-briefcase-line text-accent-500"></i>
                        </span>
                        <div>
                          <div className="text-sm font-medium text-foreground-950">商务合作</div>
                          <div className="text-sm text-foreground-500">business@heiliaobaoliao.com</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* FAQ */}
            <section>
              <h2 className="text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
                <i className="ri-question-answer-line text-accent-500"></i>
                常见问题
              </h2>
              <div className="space-y-3">
                {[
                  {
                    q: '如何向黑料爆料平台投稿？',
                    a: '您可以通过邮箱 tips@heiliaobaoliao.com 向我们投稿。我们严格保护爆料人的隐私信息，所有投稿均可匿名进行。请确保投稿内容真实可靠，并附上相关证据材料。',
                  },
                  {
                    q: '黑料爆料的文章来源是否可信？',
                    a: '我们会对每篇爆料文章进行多源交叉验证，确保信息的真实性和可靠性。我们坚持"真实可信，拒绝假消息"的原则，对无法核实的爆料不会予以发布。',
                  },
                  {
                    q: '如果发现文章内容不实，如何申诉？',
                    a: '如您认为本平台发布的某篇文章内容不实或侵犯了您的合法权益，请通过邮箱 tips@heiliaobaoliao.com 与我们联系，提供相关证明材料，我们将在24小时内进行核实处理。',
                  },
                  {
                    q: '黑料爆料平台更新频率如何？',
                    a: '我们保持全天候实时更新，编辑团队7×24小时追踪娱乐圈、网红、明星等各领域的最新动态，确保您能在第一时间获取最新爆料资讯。',
                  },
                ].map((faq, index) => (
                  <details
                    key={index}
                    className="bg-background-100 border border-background-200/50 rounded-lg group"
                  >
                    <summary className="p-5 cursor-pointer flex items-center justify-between text-foreground-950 font-medium hover:text-accent-500 transition-colors">
                      <span>{faq.q}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}